import React, { Component } from 'react';
import DriversList from './drivers-list';
import OrdersList from './orders-list';
import DispatchList from './dispatch-list';
import logo from '../../assets/images/ic_launcher.png';
import { i18n_get_value, I18N_LABELS } from '../../i18n/i18n_scripts';
import './Sidebar.css';

export default class Sidebar extends Component {

    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-title">
                    <img alt={'PizzaHut'} src={logo} className="sidebar-title-logo" />
                    <span className="sidebar-title-label">
                        <h1>{this.props.storeName}</h1>
                    </span>
                </div>
                <div style={{ overflow: 'auto' }}>
                    <DriversList
                        type="free"
                        statusFilter={this.props.statusFilter}
                        selectedDriver={this.props.selectedDriver}
                        drivers={this.props.drivers.drivers.filter(driver => driver.status === 'free')}
                        headerTitle={i18n_get_value(I18N_LABELS.SIDEBAR_DRIVERS_STATUS_FREE)}
                    />
                    <DriversList
                        type="returning"
                        statusFilter={this.props.statusFilter}
                        selectedDriver={this.props.selectedDriver}
                        drivers={this.props.drivers.drivers.filter(driver => driver.status === 'returning')}
                        headerTitle={i18n_get_value(I18N_LABELS.SIDEBAR_DRIVERS_STATUS_RETURNING)}
                    />

                    <DriversList
                        type="busy"
                        statusFilter={this.props.statusFilter}
                        selectedDriver={this.props.selectedDriver}
                        drivers={this.props.drivers.drivers.filter(driver => driver.status === 'busy')}
                        headerTitle={i18n_get_value(I18N_LABELS.SIDEBAR_DRIVERS_STATUS_BUSY)}
                    />
                    <OrdersList
                        drivers={this.props.drivers}
                        orders={this.props.orders}
                    />
                    <DispatchList
                        orders={this.props.orders}
                        drivers={this.props.drivers}
                        scheduled={this.props.scheduled}
                        data={this.props.scheduled.scheduleds}
                    />
                </div>
            </div>
        );
    }

}
